import React from 'react';
import PropTypes from 'prop-types';

export default class CommentFormComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      comment: props.comment,
    };

    this.onCommentChange = this.onCommentChange.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  onCommentChange(e) {
    this.setState({ comment: e.target.value });
  }

  handleCreate() {
    this.props.onSubmit(this.state.comment);
    this.setState({ comment: '' });
  }

  handleUpdate() {
    this.props.onUpdate(this.state.comment);
    this.setState({ comment: '' });
  }

  handleClick(e) {
    e.preventDefault();
    if(this.props.disable && this.props.toggleModal) {
      this.props.toggleModal();
    }
  }

  render() {
    const { fixed, onCancel, comment } = this.props;
    return (
      <div className="comment-form mb2">
        {
          !!this.props.disable &&
          <span>
            You must first <a href="#" onClick={this.handleClick}>login</a> or&nbsp;
            <a href="#" onClick={this.handleClick}>register</a> before you can comment.
          </span>
        }
        <div onClick={this.handleClick}>
          <textarea
            rows="5"
            value={this.state.comment}
            onChange={this.onCommentChange}
            disabled={this.props.disable}
          />
        </div>

        <div className="clearfix">
          <div className="right">
            {fixed ||
              <button onClick={onCancel} className="button-pill mr1">
                CANCEL
              </button>
            }
            {comment ?
              <button
                className="button-pill primary"
                onClick={this.handleUpdate}
                disabled={this.props.disable}
              >
                EDIT COMMENT
              </button>
              :
              <button
                className="button-pill primary"
                onClick={this.handleCreate}
                disabled={this.props.disable}
              >
                POST COMMENT
              </button>
            }
          </div>
        </div>
      </div>
    );
  }
}

CommentFormComponent.propTypes = {
  fixed: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  comment: PropTypes.string.isRequired,
  disable: PropTypes.bool,
  toggleModal: PropTypes.bool,
};

CommentFormComponent.defaultProps = {
  onCancel: event => event,
  onUpdate: event => event,
  comment: '',
  disable: false,
};
